import React from 'react';
import { Sidebar } from '@/components/Sidebar';
import { ArrowLeft, User, Radio, BarChart3, LineChart, Calendar, FileText, Database, Activity } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useNavigate } from 'react-router-dom';

export default function MockupCompactTabs() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen bg-[#0A0A0B] text-[#F8F9FA]">
      <Sidebar />
      <div className="flex-1 px-4 md:px-6 lg:px-8 py-6 md:py-8">
        <div className="flex items-center gap-4 mb-6">
          <Button
            variant="outline"
            size="icon"
            onClick={() => navigate('/ib-management/list')}
            className="border-[#2A2A2E] hover:border-[#3A3A3F] hover:bg-[#1C1C1F] text-[#F8F9FA]"
          >
            <ArrowLeft size={20} />
          </Button>
          <div>
            <h1 className="text-4xl font-bold font-heading text-[#F8F9FA]">FIRA IND</h1>
            <p className="text-[#ADB5BD]">IB Details & Performance</p>
          </div>
        </div>

        <div className="border border-[#06D6A0] bg-[#06D6A0]/5 rounded-lg p-6 mb-6">
          <h2 className="text-xl font-semibold text-[#06D6A0] mb-2">✨ SOLUTION 3: COMPACT ICON TABS</h2>
          <p className="text-[#ADB5BD]">Smaller tabs dengan icons - mobile-friendly & compact</p>
        </div>

        <Tabs defaultValue="profile" className="w-full">
          <TabsList className="bg-[#141416] border border-[#2A2A2E] mb-6 h-auto gap-1 p-1">
            <TabsTrigger value="profile" className="flex-col gap-0.5 h-auto py-2 px-3">
              <User size={16} />
              <span className="text-[10px]">Profile</span>
            </TabsTrigger>
            <TabsTrigger value="overview" className="flex-col gap-0.5 h-auto py-2 px-3">
              <Radio size={16} />
              <span className="text-[10px]">Overview</span>
            </TabsTrigger>
            <TabsTrigger value="performance" className="flex-col gap-0.5 h-auto py-2 px-3">
              <BarChart3 size={16} />
              <span className="text-[10px]">Performance</span>
            </TabsTrigger>
            <TabsTrigger value="analytic" className="flex-col gap-0.5 h-auto py-2 px-3">
              <LineChart size={16} />
              <span className="text-[10px]">Analytic</span>
            </TabsTrigger>
            <TabsTrigger value="activity" className="flex-col gap-0.5 h-auto py-2 px-3">
              <Calendar size={16} />
              <span className="text-[10px]">Activity</span>
            </TabsTrigger>
            <TabsTrigger value="campaign" className="flex-col gap-0.5 h-auto py-2 px-3">
              <FileText size={16} />
              <span className="text-[10px]">Campaign</span>
            </TabsTrigger>
            <TabsTrigger value="daily" className="flex-col gap-0.5 h-auto py-2 px-3">
              <Database size={16} />
              <span className="text-[10px]">Daily Data</span>
            </TabsTrigger>
            <TabsTrigger value="database" className="flex-col gap-0.5 h-auto py-2 px-3">
              <Database size={16} />
              <span className="text-[10px]">Database</span>
            </TabsTrigger>
            <TabsTrigger value="log" className="flex-col gap-0.5 h-auto py-2 px-3">
              <Activity size={16} />
              <span className="text-[10px]">Log</span>
            </TabsTrigger>
          </TabsList>

          <TabsContent value="profile">
            <div className="border border-[#2A2A2E] bg-[#141416] rounded-lg p-8">
              <h3 className="text-2xl font-semibold mb-4">Channel Profile Content</h3>
              <p className="text-[#ADB5BD]">IB Biography, Monthly Targets, Team Members...</p>
            </div>
          </TabsContent>

          <TabsContent value="performance">
            <div className="border border-[#2A2A2E] bg-[#141416] rounded-lg p-8">
              <h3 className="text-2xl font-semibold mb-4">Channel Performance Content</h3>
              <p className="text-[#ADB5BD]">Performance metrics...</p>
            </div>
          </TabsContent>
        </Tabs>

        <div className="mt-6 grid grid-cols-2 gap-4">
          <div className="border border-[#06D6A0] bg-[#06D6A0]/5 rounded-lg p-4">
            <h3 className="text-sm font-semibold text-[#06D6A0] mb-2">✅ KELEBIHAN:</h3>
            <ul className="text-xs text-[#ADB5BD] space-y-1">
              <li>• Compact & space-efficient</li>
              <li>• Icons help quick recognition</li>
              <li>• Modern & clean aesthetic</li>
              <li>• Mobile-friendly (stacks nicely)</li>
            </ul>
          </div>
          <div className="border border-[#E63946] bg-[#E63946]/5 rounded-lg p-4">
            <h3 className="text-sm font-semibold text-[#E63946] mb-2">❌ KEKURANGAN:</h3>
            <ul className="text-xs text-[#ADB5BD] space-y-1">
              <li>• Small text harder to read</li>
              <li>• Still 9 tabs in one row (crowded)</li>
              <li>• May need tooltip for clarity</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}